<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'" type="button"
				(click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
				<h3 class="title1level" style="margin-bottom: 20px;">Aggiungi legali</h3>
				<div class="container_tab_nav">
					<ul class="nav nav-tabs two">
						<li class="active" style="min-width: 50% !important"><a data-toggle="tab" href="#tabcontent7" aria-expanded="true">Cerca</a></li>
						<li class=""><a data-toggle="tab" href="#tabcontent8" aria-expanded="false">Inserisci</a></li>
					</ul>
					<div class="tab-content">
						<div id="tabcontent7" class="tab-pane fade active in">
							<div ricerca-anagrafiche-form #formRicercaLegale [isLegale]="true"
								[hidden]="!viewSearchMask" (onReturn)="foundedAnagrafica($event)"></div>
							<div *ngIf="isPrd" associativa-legali-form-add #formAddAssociativaRicerca
								[hidden]="viewSearchMask" (onReturn)="manageModal($event)">
								<!-- <div *ngIf="isPrd" associativa-legali-form-add (editTariffa)="onEditTariffa($event)"
								#formAddAssociativaRicerca [hidden]="viewSearchMask" (onReturn)="manageModal($event)"> -->
							</div>
						</div>
						<div id="tabcontent8" class="tab-pane fade">
							<div legale-anagrafica-form-add #formAddAnagrafica [isLegali]="true" [hidden]="haveNewAnagrafica" (onReturn)="newAnagrafica($event)"></div>
							<div *ngIf="isPrd" associativa-legali-form-add (editTariffa)="onEditTariffa($event)" #formAddAssociativaAnagrafica [hidden] = "!haveNewAnagrafica" (onReturn)="manageModal($event)"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>